import { TemplateDisplay } from "@/components/Dialogs/DisplayTemplate";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { User } from "types";

interface Link {
    name: string;
    url: string;
}

interface MessageInviteDisplayProps {
    links: Link[];
    createdBy: User;
}

const fetchLinkDetails = async (url: string) => {
    const res = await fetch(`__SITE_BASE__/api/templates/${url.replace(window.location.origin + "/template/", '')}`);
    const data = await res.json();
    return data;
};

export default function TemplateDisplayMessage({ links, createdBy }: MessageInviteDisplayProps) {
    
    const navigate = useNavigate();

    const query = useQuery({
        queryKey: ['templateDetails', links],
        queryFn: async () => {
            const linksDetails = await Promise.all(links.map(async (link) => {
                const data = await fetchLinkDetails(link.url);
                return {
                    ...link,
                    data
                };
            }));
            return linksDetails;
        },
        enabled: !!links,
        staleTime: 5 * 60 * 1000,
    });

    if (query.isLoading) return <div></div>;
    if (query.error) return <div></div>;

    return (
        <>
            {query.data && query.data.map((link: any, index: number) => (
                <>
                    {link?.data?.team && (
                        <div key={index} className="w-auto md:min-w-[30rem] p-4 bg-brand-default rounded-lg shadow-lg border border-opacity-50 border-gray-600 hover:bg-brand-default/25 hover:border-gray-700">
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col items-start gap-2">
                                    <h1 className="text-lg font-bold">
                                        {link.data.team.name}'s Template
                                    </h1>
                                </div>
                                <TemplateDisplay template={link.data.template} team={link.data.team}>
                                    <button className="px-2 py-1 bg-brand-green text-white font-bold rounded-lg">
                                        Display Template
                                    </button>
                                </TemplateDisplay>
                            </div>
                        </div>
                    )}
                </>
            ))}
        </>
    );
}